module.exports = __webpack_public_path__ + "static/img/product_images_40_h5_zh.0f97f61.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product_images_40_h5_zh.png
// module id = k+e9
// module chunks = 34